export default __webpack_public_path__ + "static/media/logo.a74729a3.png";